var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWalletActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.9484 14.6923L18.9485 14.6923L18.9476 14.6825C18.933 14.5322 18.991 14.3866 19.0934 14.2842L19.0936 14.2843L19.1029 14.2745C19.1803 14.1928 19.2949 14.1406 19.4399 14.1406H20.9375C20.9437 14.1412 20.9477 14.1423 20.9499 14.1431V15.1399C20.949 15.1401 20.9478 15.1404 20.9461 15.1406H19.4999C19.1915 15.1406 18.9655 14.914 18.9484 14.6923Z",
    fill: "#0A0A0B",
    stroke: "#0A0A0B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9667 15.2979L16.9666 15.2979L16.9687 15.3052C17.2983 16.4844 18.4323 17.1906 19.5802 17.1906H20.4502C20.7241 17.1906 20.9502 17.4168 20.9502 17.6906V17.8806C20.9502 19.6745 19.4841 21.1406 17.6902 21.1406H6.2102C4.41634 21.1406 2.9502 19.6745 2.9502 17.8806V11.1506C2.9502 10.0841 3.46106 9.14031 4.24949 8.55115L4.2495 8.55117L4.25322 8.54834C4.79843 8.13294 5.47253 7.89062 6.2102 7.89062H17.6902C19.4841 7.89062 20.9502 9.35677 20.9502 11.1506V11.5906C20.9502 11.8645 20.7241 12.0906 20.4502 12.0906H19.4302C18.7383 12.0906 18.1005 12.3629 17.6361 12.8376C17.0168 13.4473 16.7193 14.358 16.9667 15.2979Z",
    fill: "#0A0A0B",
    stroke: "#0A0A0B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0562 3.87326L15.6742 5.50976L8.18714 5.50001L9.80345 3.87372C10.978 2.70891 12.8814 2.70876 14.0562 3.87326Z",
    fill: "#0A0A0B",
    stroke: "#0A0A0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletActive);
export default __webpack_public_path__ + "static/media/walletActive.d590196a1597f607e29623250aec20a6.svg";
export { ForwardRef as ReactComponent };